<template>
  <div id="audio-cutter">
    <div
      v-if="videoUrl"
      class="video-cutter-box"
    >
      <div class="video-content">
        <videoPlayer
          :video-url="videoUrl"
          :end-play="timelineObj.cr"
          :volume="volume"
          @ended="playEnd"
          @timeupdate="timeupdate"
        ></videoPlayer>
      </div>
      <div class="video-btn">
        <videoChange @changeVideo="changeVideo"></videoChange>
        <videoControl
          :duration="duration"
          :now-time="nowTime"
          :playing="playing"
          @play="videoPlay"
        ></videoControl>
        <div></div>
        <!-- <div class="video-volume-water">
          <div class="video-water">
            <videoVolume @changeData="changeVolume"></videoVolume>
            <span>去除水印</span>
            <el-switch
              v-model="noWater"
              active-color="#2f58fe"
              inactive-color="#E0E2EA"
              :width="30"
            ></el-switch>
          </div>
        </div>-->
      </div>
      <div class="timeline-content">
        <videoTimeline
          :info="timelineObj"
          size="mini"
          @changeData="changeData"
        ></videoTimeline>
      </div>
      <div class="video-time-input">
        <div class="get-cut-time">
          <span>截取时间:</span>
          <formatTime
            :pri-time="timelineObj.cl"
            :limit-type="'left'"
            @blur="limitChange"
          ></formatTime>
          <span>-</span>
          <formatTime
            :pri-time="timelineObj.cr"
            :limit-type="'right'"
            @blur="limitChange"
          ></formatTime>
        </div>
        <div class="get-volume">
          <span class="agv-text">输出音量</span>
          <div class="slider">
            <el-slider
              v-if="videoUrl"
              v-model="volumeNumb"
              style="height:30px"
              :max="100"
              :show-tooltip="false"
              :step="1"
            ></el-slider>
          </div>
        </div>
        <div class="number-input">
          <numberInput v-model="volumeNumb"></numberInput>
        </div>

        <div
          class="cut-start-btn"
          @click="startCut"
        >
          提取音频
        </div>
      </div>
    </div>
    <div
      v-else
      class="video-file-add"
    >
      <blankAdd
        v-if="!hasFile"
        @changeFiles="changeFile"
      ></blankAdd>
      <uploadProgress
        v-else
        :percent="uploadPercent"
        @cancelHttp="cancelHttp"
      ></uploadProgress>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AudioCutter',
  components: {
    VideoPlayer: () => import('@/components/videoCutter/videoPlayer.vue'),
    VideoChange: () => import('@/components/videoCutter/videoChange.vue'),
    VideoControl: () => import('@/components/videoCutter/videoControl.vue'),
    VideoTimeline: () => import('@/components/videoCutter/videoTimeline.vue'),
    FormatTime: () => import('@/components/videoCutter/formatTimeInput.vue'),
    BlankAdd: () => import('@/components/global/blankAdd.vue'),
    UploadProgress: () => import('@/components/videoCutter/uploadProgress.vue'),
    numberInput: () => import('@/components/common/numberInput.vue')
  },
  data() {
    return {
      name: '',
      nowTime: 0,
      duration: 0,
      playing: false,
      canPlay: false,
      noWater: true,
      timelineObj: { step: 0.1, min: 0, max: 10, val: 0, cl: 0, cr: 10, maxl: 20 },
      volume: 1,
      videoUrl: '',
      sourceUrl: '',
      blobUrls: [], //用于本地缓存清除
      hasFile: false,
      uploadPercent: 0,
      source: {},
      volumeNumb: 50,
      startCutting: false,
      videoSize: 0,
      fileType: -1,
      fromOther: false
    };
  },
  computed: {
    // volumeNumb(){
    //   return this.volume * 100 / 2;
    // }
  },
  watch: {
    volumeNumb() {
      if (this.volumeNumb < 0) this.volumeNumb = 0;
      this.volume = this.volumeNumb / 50;
    }
  },
  created() {
    this.$bus.on('changeFiles', this.changeFile);
  },
  mounted() {
    this.uploadPercent = 0;
    this.$bus.on('AudioCutter.canPlay', this.canPlayFunc);
    if (this.$route.query.pipe === '1') {
      let data = this.$store.getters['completed/getPipeFiles'];
      if (data.length) {
        this.fromOther = true;
        this.canPlay = false;
        this.sourceUrl = data[0].url;
        this.videoUrl = this.$.handleAssetsUrl(data[0].url);
        this.name = data[0].name;
        this.$store.commit('uploader/setVideoUrl', data[0].url);
        //神策
        this.videoSize = data[0].size / 1024.0 / 1024;
      }
    }

    let shot = this.$store.getters['uploader/videoUrlShot'];
    if (shot.url && !(this.$route.query || {}).id && !(this.$route.query || {}).pipe) {
      this.changeFile(shot);
    }
  },
  beforeDestroy() {
    this.$bus.off('changeFiles', this.changeFile);
    this.$bus.off('AudioCutter.canPlay', this.canPlayFunc);
    this.blobUrls.forEach((url) => {
      window.URL.revokeObjectURL(url);
    });
  },
  methods: {
    async changeFile(data) {
      this.fromOther = false;
      if (data.blob) {
        this.hasFile = true;
        //todo: test
        await this.uploadTask(data.blob);
        this.hasFile = false;
        this.canPlay = false;
        this.videoUrl = window.URL.createObjectURL(data.blob);
        this.blobUrls.push(this.videoUrl);
        //神策
        this.videoSize = data.blob.size / 1024.0 / 1024;
      } else if (data.url) {
        this.canPlay = false;
        this.sourceUrl = data.url;
        this.videoUrl = this.$.handleAssetsUrl(data.url);
        //神策
        this.videoSize = (data.size || 0) / 1024.0 / 1024;
      }
      this.name = data.name;
      this.fileType = data.fileType;
    },
    changeVideo() {
      let fileObj = null;
      if (this.playing) {
        this.videoPlay();
      }
      this.$modal.show('selectModal', {
        onFile: (file) => {
          fileObj = file;
          this.timelineObj.val = 0;
          //神策
          this.videoSize = file.size / 1024.0 / 1024;
          this.fromOther = false;
          this.fileType = -1;
          // 读取到本地文件时回调
        },
        onUrl: (url) => {
          // 文件全送到云端时回调
          this.canPlay = false;
          if (fileObj) {
            this.videoUrl = window.URL.createObjectURL(fileObj);
            this.blobUrls.push(this.videoUrl);
            this.name = fileObj.name;
          } else {
            this.videoUrl = this.$.handleAssetsUrl(url);
          }
          this.sourceUrl = url;
          this.$modal.hide('selectModal');
          this.timelineObj.val = 0;
          this.fromOther = false;
        },
        onInfo: (info) => {
          // 点击我的作品打卡列表弹窗，选一个作品然后点击确定时回调
          if (info.url) {
            this.canPlay = false;
            this.sourceUrl = info.url;
            this.name = info.title;
            this.videoUrl = this.$.handleAssetsUrl(info.url);
            this.$modal.hide('selectModal');
            this.timelineObj.val = 0;
            this.videoSize = info.size;
            this.fileType = info.fileType;
            this.fromOther = false;
          }
        }
      });
    },
    canPlayFunc(data) {
      if (this.canPlay) return;
      this.nowTime = 0;
      this.timelineObj.val = 0;
      this.duration = data;
      this.timelineObj.max = this.duration;
      this.timelineObj.cl = 0;
      this.timelineObj.cr = this.duration * 0.6;
      this.timelineObj.maxl = this.duration;
      this.canPlay = true;
      this.$store.commit('common/setEditing', true);
      //神策
      if (!this.videoUrl.startsWith('https://resources.laihua.com')) {
        this.$sensors.track('toolVideoUpload', {
          tool_type: '音频宝',
          video_source: this.fromOther ? '其他工具' : '本地上传',
          video_duration: this.duration,
          video_size: this.videoSize
        });
      } else {
        let v_s = this.fromOther ? '其他工具' : '本地上传';
        if (this.fileType === 27) v_s = '作品库';
        if (this.fileType === 26) v_s = '视频库';
        this.$sensors.track('toolVideoUpload', {
          tool_type: '音频宝',
          video_source: v_s,
          video_duration: this.duration,
          video_size: this.videoSize
        });
      }
    },
    videoPlay() {
      if (!this.canPlay) return;
      let ob = {};
      if (this.playing) {
        ob.play = false;
      } else {
        ob.play = true;
        if (this.nowTime >= this.timelineObj.cr) {
          ob.time = this.timelineObj.cl;
          this.timelineObj.val = this.timelineObj.cl;
        }
      }
      this.playing = !this.playing;
      this.$bus.emit('videoPlayer.play', ob);
    },
    playEnd() {
      this.playing = false;
      this.nowTime = this.timelineObj.cr;
      this.timelineObj.val = this.nowTime;
    },
    timeupdate(time) {
      if (this.playing) {
        this.nowTime = time;
        this.timelineObj.val = this.nowTime;
      }
    },
    changeData(data) {
      if (data.type !== 'change') return;
      if (data.action === 'handle' || data.action === 'click') {
        this.nowTime = data.val;
        this.timelineObj.val = data.val;
        this.$bus.emit('videoPlayer.play', { play: this.playing, time: data.val });
      } else if (data.action === 'cutRight') {
        this.nowTime = data.val;
        this.timelineObj.val = data.val;
        this.timelineObj.cr = data.val;
        this.playing = false;
        this.$bus.emit('videoPlayer.play', { play: false, time: data.val });
      } else if (data.action === 'cutLeft') {
        this.nowTime = data.val;
        this.timelineObj.val = data.val;
        this.timelineObj.cl = data.val;
        this.$bus.emit('videoPlayer.play', { play: this.playing, time: data.val });
      }
    },
    limitChange(data) {
      if (data.type === 'left') {
        if (data.val > this.timelineObj.cr - 1) {
          this.$bus.emit('formatTimeInput.init');
          //console.log(`请输入范围为0~${this.timelineObj.cr - 1}的值`);
        } else {
          this.timelineObj.cl = data.val;
          this.nowTime = data.val;
          this.timelineObj.val = data.val;
          this.playing = false;
          this.$bus.emit('videoPlayer.play', { play: false, time: data.val });
        }
      } else {
        if (data.val < this.timelineObj.cl + 1 || data.val > this.timelineObj.max) {
          this.$bus.emit('formatTimeInput.init');
          //console.log(`请输入范围为${this.timelineObj.cl + 1}~${this.timelineObj.max}的值`);
        } else {
          this.timelineObj.cr = data.val;
          this.nowTime = data.val;
          this.timelineObj.val = data.val;
          this.playing = false;
          this.$bus.emit('videoPlayer.play', { play: false, time: data.val });
        }
      }
    },
    changeVolume(volume) {
      this.volume = (volume / 100) * 2;
    },
    async startCut() {
      if (this.startCutting) return;
      this.startCutting = true;
      let info = await this.$http.get(`/common/material/avinfo?key=${this.sourceUrl}`);
      let hasAudio = false;
      if (info && info.data && info.data.streams) {
        for (let i = 0; i < info.data.streams.length; i++) {
          hasAudio = info.data.streams[i].codec_type == 'audio';
          if (hasAudio) break;
        }
      }
      if (!hasAudio) {
        this.$message({
          message: '视频没有音轨',
          type: 'error',
          center: true
        });
        this.startCutting = false;
        return;
      }
      //神策
      let v_s = '其他工具';
      if (this.fileType === 27) v_s = '作品库';
      if (this.fileType === 26) v_s = '视频库';
      this.$sensors.track('toolVideoProcess', {
        tool_type: '音频宝',
        video_source: v_s
      });

      //console.log('startCut startCut startCut', info);
      let body = {
        type: 7,
        key: this.sourceUrl,
        bg: this.timeToFormat(this.timelineObj.cl),
        ed: this.timeToFormat(this.timelineObj.cr),
        volume: this.volume
      };

      //if (!this.aaaaaa) return;

      let resp = await this.$http.post('/onlineTask', body);

      if (resp.status !== 200 || resp.data.code !== 200) {
        this.$message({
          message: '裁剪失败',
          type: 'error',
          center: true
        });
        this.startCutting = false;
        return;
      }
      let result = resp.data.data;
      if (result) {
        //任务进行中
        this.$bus.emit('maskLayer', {
          show: true,
          type: 'audioCutter',
          info: {
            name: this.name,
            taskId: result.taskId,
            key: result.key,
            newkey: result.newkey,
            thumbnailkey: result.thumbnailkey,
            duration: this.timelineObj.cr - this.timelineObj.cl
          }
        });
      } else {
        this.$message({
          message: '裁剪失败',
          type: 'error',
          center: true
        });
      }
      this.startCutting = false;
    },
    async uploadTask(file) {
      // 判断上传限制
      if (file.size > 200 * 1024 * 1024) {
        this.$message({
          message: `文件"${file.name}"大小超过限制`,
          type: 'error',
          center: true
        });
        return;
      } else if ((await this.$.getDuration(file)) > 3600) {
        this.$message({
          message: `文件"${file.name}"时长超过限制`,
          type: 'error',
          center: true
        });
        return;
      }

      // 用于取消上传
      let CancelToken = this.$http.CancelToken;
      this.source = CancelToken.source();
      let filesize = file.size;
      let perSize = 6 * 1024 * 1024; //每片大小
      let chunkNumbers = Math.ceil(filesize / perSize); // 总片数，向上取整
      let start = 0; //分片开头
      let end = 0; //分片结尾
      let filename = new Date().getTime() + '.mp4';
      let uploadCompletedNumbers = 0;

      for (let i = 0; i < chunkNumbers; i++) {
        start = end;
        end = start + perSize;
        if (end > filesize) {
          end = filesize;
        }
        const chunk = file.slice(start, end);
        const formData = new FormData();
        formData.append('files[]', chunk, filename);
        let result = await this.uploadChunk({
          formData: formData,
          index: i,
          perSize: perSize,
          filesize: filesize,
          chunkNumbers: chunkNumbers
        });
        if (result) {
          uploadCompletedNumbers++;
          this.uploadPercent = (uploadCompletedNumbers / chunkNumbers) * 100;
        } else {
          break; //一个分片上传失败，就判断为整体失败
        }
      }

      if (uploadCompletedNumbers == chunkNumbers) {
        let result = await this.mergeBlock({ filename: filename, chunkNumber: chunkNumbers });
        if (result) {
          this.sourceUrl = result.filename;
          return;
        }
      }

      this.$message({
        message: '上传失败',
        type: 'error',
        center: true
      });
    },
    uploadChunk(query) {
      return new Promise((resolve) => {
        this.$http({
          url: `/upload/fileBlock?currentChunkSize=${query.perSize}&index=${query.index}&chunkSize=${query.filesize}&totalChunks=${query.chunkNumbers}`,
          method: 'post',
          data: query.formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          cancelToken: this.source.token,
          timeout: 10 * 60 * 1000
        })
          .then((res) => {
            if (res.status === 200 && res.data.code === 200) {
              resolve(res.data.data);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    mergeBlock(body) {
      return new Promise((resolve) => {
        this.$http
          .post('/upload/mergeBlock', body)
          .then((res) => {
            if (res.status === 200 && res.data.code === 200) {
              this.$store.commit('uploader/setVideoUrl', res.data.data.filename);
              resolve(res.data.data);
            }
          })
          .catch(() => {
            resolve(false);
          });
      });
    },
    cancelHttp() {
      // 取消上传
      this.source.cancel('用户取消上传');
      this.videoUrl = '';
      this.sourceUrl = '';
      this.canPlay = false;
      this.hasFile = false;
    },
    timeToFormat(time) {
      let points = Math.round(time * 10) % 10;
      let minute = Math.floor(time / 60);
      let secound = Math.floor(time - minute * 60);
      minute = minute.toString().padStart(2, 0);
      secound = secound.toString().padStart(2, 0);
      points = points.toString().padEnd(3, 0);
      return `00:${minute}:${secound}.${points}`;
    }
  }
};
</script>

<style scoped lang="scss">
/* @import url(); 引入css类 */
#audio-cutter {
  width: 100%;
  height: 100%;
  padding: 17px 65px 0 74px;
  background-color: #f6f7fb;
  font-size: 14px;
  color: #333333;

  * {
    user-select: none;
  }

  .video-cutter-box,
  .video-file-add {
    width: 100%;
    height: calc(100% - 54px);
  }
  .video-content {
    width: 100%;
    height: calc(100% - 229px);
  }
  .video-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px auto 44px;
  }
  .video-water {
    display: flex;
    align-items: center;

    span {
      margin-left: 30px;
      margin-right: 7px;
    }
  }
  .timeline-content {
    width: 100%;
    margin: 10px 0;
  }

  .video-time-input {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16px auto 0;

    .get-cut-time {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 350px;
      @media (max-width: 1600px) {
        width: 250px;
      }
    }
    .get-volume {
      display: flex;
      justify-self: start;
      align-items: center;
      margin: 0 0 0 40px;
      .agv-text {
        width: 60px;
      }
      .slider {
        width: 180px;
        height: 40px;
        margin: 0 10px;
        @media (max-width: 1600px) {
          width: 108px;
          height: 35px;
        }
        /deep/ .el-slider__button {
          border: 0px !important;
          background: #2f58fe;
          box-shadow: 0px 5px 30px 0px rgba(22, 64, 234, 0.16);
        }
        /deep/ .el-slider__runway {
          @media (max-width: 1600px) {
            height: 4px;
          }
          .el-slider__bar {
            background: #2f58fe;
            @media (max-width: 1600px) {
              height: 4px;
            }
          }
          .el-slider__button {
            @media (max-width: 1600px) {
              margin-top: -3px;
              width: 12px;
              height: 12px;
            }
          }
        }
      }
    }
    .number-input {
      width: 60px;
      height: 40px;
      @media (max-width: 1600px) {
        width: 50px;
        height: 30px;
      }
    }

    .cut-start-btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      margin-left: 50px;
      background-color: #2f58fe;
      border-radius: 4px;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;

      &:hover {
        background-color: #3d7dff;
      }
      @media (max-width: 1600px) {
        font-size: 12px;
        width: 84px;
        height: 30px;
        line-height: 30px;
        margin-left: 14px;
      }
    }
  }
}
</style>
<style lang="scss">
#audio-cutter {
  .el-switch__core {
    height: 16px;
    &:after {
      width: 14px;
      height: 14px;
      top: 0;
    }
  }

  .el-switch.is-checked .el-switch__core::after {
    margin-left: -14px;
  }
}
</style>
